<ion-header>
  <ion-toolbar >
    <div class="toolbar">
      <ion-title>Select Brands</ion-title>
      <!-- <ion-icon name="close-outline" class="mouse" (click)="modal.dismiss()"></ion-icon> -->
      <div class="d__flex ion-align-items-center gap-5">
        <ion-button fill="clear" size="small" class="fnt-16 ion-text-capitalize"  (click)="modal.dismiss()">Close</ion-button>
        <!-- <ion-button fill="clear" size="small" class="fnt-16 ion-text-capitalize save_btn" color="primary-bg" (click)="save_value()">Save</ion-button> -->
      </div>
    </div>
    <!-- <ion-buttons slot="end">
      <ion-button class="close-btn" (click)="modal.dismiss()">
        <ion-icon class="fnt-14" src="assets/icon/close.svg"></ion-icon>
      </ion-button>
    </ion-buttons> -->
  </ion-toolbar>
</ion-header>
<ion-content>
  <!-- <ion-item lines="full" *ngFor="let item of db.get_product_brands" (click)="get_selected_brands(item)">
    <ion-label>{{item.brand_name}}</ion-label>
    <ion-icon slot="end" name="chevron-forward-outline"></ion-icon>
  </ion-item> -->

 <div class="categories" *ngIf="db.get_product_brands && db.get_product_brands.length != 0">

  <div class="ion-activatable ripple-parent rectangle mouse" (click)="check_parent('',item)" *ngFor="let item of db.get_product_brands">
    <ion-ripple-effect></ion-ripple-effect>
     <div class="d__flex box ">
       <ion-label class="txt-cap">{{item.brand_name}}</ion-label>
       <!-- (ionChange)="check_parent($event,item)" -->
       <ion-toggle mode="ios" [(ngModel)]="item.selected"></ion-toggle>
     </div>
  </div>

  <!-- <ion-item lines="none" *ngFor="let item of db.get_product_brands">
    <ion-label>{{item.brand_name}}</ion-label>
    <ion-toggle mode="ios" [(ngModel)]="item.selected"></ion-toggle>
  </ion-item> -->
 </div> 

 <app-no-record-found *ngIf="db.get_product_brands && db.get_product_brands.length == 0" [column]="true" [height]="db.ismobile ? 'calc(100vh - 280px)' : 'calc(100vh - 112px)'" heading="There’s no brands found" [image]="'assets/no_brand.svg'"></app-no-record-found>

</ion-content>
